export default __webpack_public_path__ + "static/media/secured-by-dataswift.ae2bdd0f.svg";